import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import type { PipelineStage } from "./flowData";

interface PipelinePhaseCardProps {
  stage: PipelineStage;
}

/** A single AI-pipeline stage card, data-driven from a `PipelineStage`. */
export function PipelinePhaseCard({ stage }: PipelinePhaseCardProps) {
  const { stage: stageNumber, title, description, icon: Icon, color, badges } = stage;
  return (
    <Card className={`border-l-4 ${color.border} py-5 gap-4`}>
      <div className="flex items-start gap-4 px-5">
        <div
          className={`flex items-center justify-center size-10 rounded-full shrink-0 ${color.bg}`}
        >
          <Icon className={`size-5 ${color.text}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-xs font-semibold uppercase tracking-wide ${color.text}`}>
              Stage {stageNumber}
            </span>
          </div>
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
            {description}
          </p>
          <div className="flex flex-wrap gap-1.5 mt-3">
            {badges.map((badge) => (
              <Badge
                key={badge}
                variant="secondary"
                className="text-[11px] px-2 py-0.5 font-normal"
              >
                {badge}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
